import { useSearchParams } from "react-router";
import { PublicBookingRuntime } from "@/components/services/public-booking-runtime";
import { useAuth } from "@/lib/auth-provider";

export default function BookingSchedulePage() {
  const { session } = useAuth();
  const [searchParams] = useSearchParams();
  const serviceId = searchParams.get("serviceId");

  return (
    <div className="space-y-6">
      <div className="max-w-3xl">
        <p className="text-xs font-semibold uppercase tracking-[0.24em] text-[var(--color-primary)]">Stero booking</p>
        <h1 className="mt-3 text-3xl font-semibold tracking-tight text-[var(--color-foreground)]">
          Customer-facing booking runtime
        </h1>
        <p className="mt-3 text-sm leading-6 text-[var(--color-muted-foreground)]">
          This route now mirrors the same public booking engine that powers published pages, so service teams can verify the real experience instead of an inspection-only seam.
        </p>
      </div>

      <PublicBookingRuntime
        tenantId={session?.activeOrganizationId ?? null}
        initialServiceId={serviceId}
      />
    </div>
  );
}
